import Api from "@root/components/api";

export default class ToyMutation {
    async save(toy) {
        let query = `mutation ($input: SaveToyInput!) {
            saveToy(input: $input)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            input: {
                id: toy.id,
                name: toy.name ?? "", 
                description: toy.description,                
                imageUrl: toy.imageUrl,
                kind: toy.kind,
            }
        }});
    }   

    async buy(toyId) {
        let query = `mutation ($toyId: String!) {
            buyToy(toyId: $toyId)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            toyId: toyId,
        }});
    }   
}